import React, { useState, useEffect } from 'react'
import { Message, Panel } from 'rsuite'
import DailyPayBookSeach from './DailyPayBookSeach'
import DailyPayBookTable from './DailyPayBookTable'
import { doneLoading, startLoading } from '../../utils/loading'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import {
  ExportPaybookData,
  downloadPaybookPdf,
  searchPaybookData,
} from '../../redux/actions/accountingReport'
import moment from 'moment'
import { DATE_TIME_FORMAT } from '../../constants/date'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'

export default function DailyPayBookWidget({ schema: _schema, ...props }) {
  const { projectCode } = props

  const [formSchema, setFormSchema] = useState(_schema)
  const [isLoading, setIsLoading] = useState()
  const [formTable, setFormTable] = useState()
  const [searchData, setSearchData] = useState()

  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)

  useEffect(() => {
    setFormSchema(_schema)
    setFormTable(_schema?.formTable)

    // let request = {
    //   period: 0,
    //   startDate: '',
    //   endDate: '',
    // }
    // handlePreviewFile(request)
  }, [_schema])

  const handleSearch = async (data) => {
    startLoading()
    setIsLoading(true)
    setSearchData(data)
    try {
      const response = await searchPaybookData(projectCode, data)
      if (response) {
        setFormTable(response)
      }
    } catch (e) {
      console.log('e', e)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleExport = async (data) => {
    startLoading()
    setIsLoading(true)
    try {
      var fileName = `สมุดรับ-จ่าย_${projectCode}_${moment(new Date()).format(DATE_TIME_FORMAT)}`

      const file = await ExportPaybookData(projectCode, data)
      downloadFile(file, fileName)
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handlePreviewFile = async (data) => {
    startLoading()
    setIsLoadingPDF(true)
    setSearchData(data)
    try {
      var file = await downloadPaybookPdf(projectCode, data)
      setPreviewPdf(file)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    setIsLoadingPDF(false)
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema.header} bordered>
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        <div style={{ marginTop: 30 }}>
          <DailyPayBookSeach
            schema={formSchema?.searchForm}
            loading={isLoading}
            onSearch={handlePreviewFile}
            onExport={handleExport}
            //onExport={handleExport}
            projectStartDate={formSchema?.projectInfo?.projectStartDate}
            projectEndDate={formSchema?.projectInfo?.projectEndDate}
          />
        </div>

        {previewPdf && (
          <div style={{ marginTop: 30 }}>
            <PdfRenderWidgets
              file={previewPdf}
              isLoading={isLoadingPDF}
              isShaded={false}
              onReload={() => handlePreviewFile(searchData)}
              loadingMessage="กรุณารอสักครู่ ระบบกำลังสร้าง PDF สมุดรับ จ่าย รายวัน..."
            />
          </div>
        )}

        {/* <DailyPayBookTable
          schema={formTable || formSchema?.formTable}
          loading={isLoading}
          onPreview={onPreview}
          onDownload={onDownload}
          //onReload={handleSearch}
        /> */}
      </Panel>
    </>
  )
}
